<template>
  <div class = "questionnaire-wrap">
    <Spin v-if = 'isLoading' fix></Spin>
    <div  v-for = "(item,index) in fields" :key = "index">
      <ItemField :isVertical = 'isVertical' :isPreview = 'isPreview' :ref = '`itemField${index}`' :allFieldsVal='allFieldsVal' :doubleCallFlag='doubleCallFlag' :fieldData = "item" @change = '_fieldChange'  />
    </div>
    <!-- <Button @click = "_save">保存</Button> -->
  </div>
</template>

<script>
import FieldType,{fieldInitValue} from './fieldType'
import ItemField from './itemField.vue'
import minixBase64enDe from './mdwfCompUtil/minixBase64enDe.js'
export default {
  props: {
    mtId: String,
    moId: String,
    tenantId: String ,
    businessKey: String,
    busType: String,
    isPreview: Boolean,
    isVertical: Boolean,
    defaultValue: Object,
    data: Object,
    objType: String
  },
  components: {
    ItemField
  },
  computed: {
      moId(){
          return this.data?this.data.moId:''
      },
      mtId(){
          return this.data?this.data.mtId:''
      },
      tenantId(){
          return this.data?this.data.tenantId:''
      },
      busType(){
          return this.data?this.data.busType:''
      },
      businessKey(){
          return this.data?this.data.businessKey:''
      },
      defaultValue(){
          return this.data?this.data.defaultValue:''
      },
      OBJECT_NAME(){
        if(this.objType&&this.objectNameMap[this.objType]){
          return this.objectNameMap[this.objType]+JSON.parse(localStorage.user).info.tenantId
        }
        return "scmd_work_orders_"+JSON.parse(localStorage.user).info.tenantId
      }
  },
  data(){
    return {
      fields: [],//dat
      isLoading: false,
      allFieldsVal: {},//所有字段的值
      objectNameMap: {
        scwf: 'scmd_work_orders_',
        sccm: 'sccm_cust_info_',
        ask: 'scmd_ask_info_',
      },
      doubleCallFlag: false,//双呼标识
      encryption: ''
    }
  },
  watch: {
    'moId': {
      handler(newValue){
        console.log(newValue)
        if(newValue){
          this.getData()
        }
      }
    },
    'busType': {
      handler(newValue){
        console.log(newValue)
        if(newValue){
          this.getData()
        }
      }
    }
  },
  created(){
    console.log('data',this.data)
    console.log('objtype',this.objType)
    if(this.data.isFlowType == '1'){
      this.getFlowFieldData()
    }else{
      this.getData()
    }
    
  },
  mounted(){
    // this.getData()
  },
  methods: {
    //树结构获取关联字段
    getRelatFields(id,fieldCname){
      //先删除所有关联的字段
        this.deleRelatFieldsByFieldCname(fieldCname)
        this.$http.get('/scmd/treeRely/getLeafNodeRelyFieldList?leafNodeId='+id).then(({data})=>{
            let relatFields = []
            if(data.returnCode == 0){
                relatFields = data.beans
                //反转数组，插入时候顺序会回来
                relatFields.reverse()
                for(let i = 0;i < relatFields.length;i++){
                  //给关联的字段附一个关联值，可以通过这个值找到关联的父级字段
                  relatFields[i]._relatParentField = fieldCname
                  relatFields[i].isShow = true
                }
                //给被关联字段赋值
                this._setFieldsVal(relatFields,this.allFieldsVal)
                //插入关联的元素
                this.insetFieldsByFieldCname(fieldCname,relatFields)
            }
        })
    },
    deleRelatFieldsByFieldCname(fieldCname){
      for(var i = 0;i<this.fields.length;i++){
        if(this.fields[i]._relatParentField === fieldCname){
          this.fields.splice(i,1)
          i--
        }
      }
    },
    insetFieldsByFieldCname(fieldCname,_fields){
      let index = 0
      for(var i = 0;i<this.fields.length;i++){
        if(this.fields[i].fieldCname === fieldCname){
          for(let j = 0;j < _fields.length;j++){
            this.fields.splice(i+1,0,_fields[j])
          }
          console.log(this.fields)
          break
        }
      }
    },
    _verifyAllField(){
      if(this.isPreview){//预览模式不校验
        return true
      }
      let {fields} = this
      let access = true
      for(let i = 0;i<fields.length;i++){
        if(fields[i].isShow == 1&&fields[i].writeable){//显示、可编辑状态才校验
          if(this.$refs[`itemField${i}`][0].verify()){
            access = false
          }
        }
      }
      return access
    },
    _fieldChange(field){
      if(field.relation){
        this.showRelationField(field)
      }
      if(field.fieldType == '22'){
        if(field._value&&field._value.length){
          //id是级联的叶节点的值
          let id = field._value[field._value.length-1]
          this.getRelatFields(id,field.fieldCname)
        }else{
          this.deleRelatFieldsByFieldCname(field.fieldCname)
        }
      }
      if(field.fieldType == '17'&&field.relationFieldData){
          let opt = field.relationFieldData
            let currentData = Object.keys(opt.currentObjectBean)
            for (let i = 0; i <= currentData.length - 1; i++) {
                for (let j = 0; j < this.fields.length; j++) {
                    if (this.fields[j].fieldType ==="18") {
                        if (
                            currentData[i] == this.fields[j].referenceCname &&
                            field.businessLinkages == this.fields[j].businessLinkages
                        ) {
                            if(field.relationFieldData.__isEmpty){//引用字段清空的情况
                                this.fields[j].value = ""
                            }else{
                                this.fields[j].value = opt.currentObjectBean[currentData[i]]
                            }
                        }
                    }
                }
            }
      }
    },
    showRelationField(field){
      this.recursionFields(this.fields,(item) => {
        if(item._releationParents && item._releationParents.length){
          let isShow = false
          for(let i in item._releationParents){
            if(item._releationParents[i].field.value == item._releationParents[i].value){
              isShow = true
            }
          }
          item.isShow = isShow
        }
      })
    },
    //获取表单数据(不带流程)
    getData(){
      if(!this.moId||!this.busType){
        return
      }
      this.isLoading = true
      this.$http.get(`/scmd/listlayout/getFormLayoutFieldList?moId=${this.moId }&busType=${this.busType}`)
      .then(this.handleFieldCb)
    },
    //获取表单数据(带流程)
    getFlowFieldData(){
      this.$http.get(`/scmd/flow/getNodeFiledAttributes?modelId=${this.data.modelId }&taskId=${this.data.taskId||''}`)
      .then(this.handleFieldCb)
    },
    handleFieldCb({data}){
      console.log('问卷布局',data)
      this.isLoading = false
      if(data.returnCode == 0){
        let fields = data.beans
        this.recursionFields(fields,item => {
          if(item.relation){
            let _relation = item.relation
            for(let i in _relation){
              let _relations = _relation[i].relation
              let _value = _relation[i].value
              for(let k in _relations){
                let _field = this.getFieldByCname(_relations[k].fieldCname,fields)
                if(!_field){
                  continue
                }
                _field._releationParents = _field._releationParents || []
                _field._releationParents.push({
                  value: _value,
                  field: item
                })
              }
            }
          }
          item.value = fieldInitValue(item.fieldType,item)
          if(this.defaultValue&&this.defaultValue[item.fieldCname]){//字段回显传入的默认值
            item.value = this.defaultValue[item.fieldCname]
          }
          item.__value__key__ = '' //预览时展示用
          if(item.fieldCname=='cust_phone' && this.data && this.data.custPhone){ //接续新建传默认手机号
            item.__value__key__ = this.data.custPhone

          }else if(item.fieldCname=='encryption' && this.data && this.data.encryption!==undefined){//接续新建传加密字段
            item.__value__key__ = this.data.encryption=='1'?'是':(this.data.encryption=='0'?'否':'')
          }
        })
        this.fields = fields
        // console.log('初始化好的字段',fields)
        console.log('接续新建==',this.data)
        if(this.data.encryption!==undefined && this.data.custPhone){//接续新建
          this.doubleCallFlag = false;
          this.allFieldsVal.encryption = this.data.encryption=='1'?"是":"否";
          // 接续-加密新建 对加密字段强赋值
          this.recursionFields(this.fields,item => {
            if(item.fieldCname=='encryption'){
              item.value = this.data.encryption;
              item.writeable = false;
            }
            if(item.fieldCname=='cust_phone'){
              item.value = this.data.custPhone;
            }
          })
        }
        console.log(this.mtId)
        if(this.mtId){
          this.getAllFieldValue()
        }
      }
    },
    //通过fieldCname找到对应字段对象 加下标_id是value，不加id的字段名是key
    getFieldByCname_id(fieldCname,fields){
      fields = fields || this.fields
      for(let i in fields){
        if((`${fields[i].fieldCname}_id` == fieldCname)){
          return fields[i]
        }
      }
    },
    //通过fieldCname找到对应字段对象
    getFieldByCname(fieldCname,fields){
      fields = fields || this.fields
      for(let i in fields){
        if(fields[i].fieldCname == fieldCname){
          return fields[i]
        }
      }
    },
    //遍历字段
    recursionFields(fields,cb){
      for(let i in fields){
        cb&&cb(fields[i])
      }
    },
    //获取字段值 通过mtId
    getAllFieldValue(){
      // var tenantId = JSON.parse(localStorage.user).info.tenantId
      var tenantId = this.tenantId
      var mtId = this.mtId
      var params = {
        Head: {
          method: 'select',
          version: 'v1.0'
        },
        Data: [
          {
            // optionType: 'update',
            moId: this.moId,
            OBJECT_NAME: this.OBJECT_NAME,
            whereOf: `is_delete =0  and tenant_id=${tenantId} and mt_id=${mtId}`,
            operFields: "*",
            page: {
              pageNumber: 1,
              pageSize: 10
            }
          }
        ]
      }
      // if(!this.isPreview){
      //   params.Data[0].optionType = 'update'
      // }
      this.$http.post(`/scmd/custom/operCustom`,params).then(({data}) => {
      // this.$http.get(`scmd/fields/getFieldDetailByMtId?moId=${this.moId}&mtId=${this.mtId}`).then(({data}) => {
        console.log(data)
        if(data.returnCode == 0){
          if(!data.beans.length){
            return
          }
          for(let i in data.beans[0]){
            // 编辑时 解密渲染 不和接续相互影响
            if(i=='encryption_id' && data.beans[0][i]=='1'){
              data.beans[0]['cust_phone']?data.beans[0]['cust_phone']=minixBase64enDe.base64Enshow(data.beans[0]['cust_phone'],'1'):'';
              data.beans[0]['cust_name']?data.beans[0]['cust_name']=minixBase64enDe.base64Enshow(data.beans[0]['cust_name'],'1'):'';
              break;
            }
          }
          this.allFieldsVal = data.beans[0]
          this.doubleCallFlag = true;
          this.businessKey = this.allFieldsVal.business_key
          this._setFieldsVal(this.fields,this.allFieldsVal)
        }
      })
    },
    _setFieldsVal(_fields,allFieldsVal){
      this.recursionFields(_fields,(itemField)=>{
        let itemValue = ''
        if(allFieldsVal[`${itemField.fieldCname}_id`]){
          itemValue = allFieldsVal[`${itemField.fieldCname}_id`]
        }else{
          itemValue = allFieldsVal[`${itemField.fieldCname}`] || ''
        }
        itemField.__value__key__ = allFieldsVal[`${itemField.fieldCname}`] || ''
        if(this.defaultValue&&this.defaultValue[itemField.fieldCname]){
          itemField.__value__key__ = this.defaultValue[itemField.fieldCname]
        }
        if(((itemField.fieldType == '4') || (itemField.fieldType == '10'&&itemField.timeType == 1))&&!this.isPreview&&itemField.writeable){
          let arr = []
          let vals = itemValue.split(',')
          for(let k in vals){
            if(vals[k]){
              arr.push(vals[k])
            }
          }
          itemField.value = arr//.join(',')
          if(vals.length == 0){
            itemField.__value__key__ = ""
          }
        }else if(itemField.fieldType == '14' && this.isPreview){//查看时，类型为14的值需要格式化
          const getIndex = (str,strpram,index) => {
              var strValue=str;
              var strValue1="";
              var value=0;
              for(var i =0;i < index;i++){
              strValue1 = strValue.substring(0,strValue.indexOf(strpram));
              strValue = strValue.substring(strValue1.length+1);
              value += (strValue1.length+1);
              }
              return value;
            }
            let _val14 = itemValue,_val141 = itemValue
            let _i = getIndex(_val14,"/",3)
            _val141 = _val141.substring(0,_i-1).split("/")
            let _val142 = _val14.substring(_i,_val14.length)
            itemField.__value__key__ = _val141.join("")+_val142
            itemField.value = itemValue
            console.log("quest===",itemField)
        }else if(itemField.fieldType == '22'){
          console.log('relatId',itemField.value)
            if(itemValue){
              itemField.value = itemValue.split(',')
              //初始化赋值的时候调用关联字段
              if(itemField.value&&itemField.value.length){
                //id是级联的叶节点的值
                let id = itemField.value[itemField.value.length-1]
                this.getRelatFields(id,itemField.fieldCname)
              }
              let treeData = JSON.parse(itemField.dicCode)
              itemField.__value__key__ = this._getTreeLabelByValue(treeData,itemValue.split(','))
            }   
        }else{
          itemField.value = itemValue
        }
        this._fieldChange(itemField)
      })
    },
    _getTreeLabelByValue(treeData,value){
      let str = ""
      if(value.length){
        _getVal(treeData,value,0,(text)=>{
          if(str){
            str+=`/${text}`
          }else{
            str+=text
          }
        })
      }
      function _getVal(treeArr,val,index,cb){
        for(let i = 0;i<treeArr.length;i++){
          if(treeArr[i].value == val[index]){
            cb&&cb(treeArr[i].label)
            if(treeArr[i].children&&treeArr[i].children.length){
              _getVal(treeArr[i].children,val,index+1,cb)
            }
          }
        }
      }
      return str
    },
    _reset(){
      this.recursionFields(this.fields,item => {
        item.value = fieldInitValue(item.fieldType,item)
        if(this.defaultValue&&this.defaultValue[item.fieldCname]){//字段回显传入的默认值
          item.value = this.defaultValue[item.fieldCname]
        }
      })
      this.$nextTick(()=>{
        let fields = this.fields
        for(let i = 0;i<fields.length;i++){
          if(fields[i].isShow == 1&&fields[i].writeable){//显示、可编辑状态才校验
            this.$refs[`itemField${i}`][0]&&this.$refs[`itemField${i}`][0]._reset()
          }
        }
      })
    },
    //点击取消或关闭弹窗
    cancel() {
      this._reset()
    },
    _save(params){
      // console.log(this._verifyAllField())
      if(!this._verifyAllField()|| this.isHttping){
        return false
      }
      this.isHttping = true
      // console.log(this._getVal())
      if(this.mtId){
        return this._editSave()
      }else{
        return this._addSave(params)
      }
      
    },
    _getVal(){
      let val = {}
      this.getEncryption();
      this.recursionFields(this.fields,(field)=>{
        if(field.isShow != 0){
          //复选、时间范围特殊处理
          if(field.value && ((field.fieldType == '4') || (field.fieldType == '10'&&field.timeType == 1)) && field.value.length){
            val[field['fieldCname']] = field['value'].join(',')
            // try{
            //   val[field['fieldCname']] = field['value'].join(',')
            // }catch(e){
            //   val[field['fieldCname']] = field['value']
            // }
          }else if(field.value && field.fieldCname=='cust_phone'){
            // 加密
            val[field['fieldCname']] = minixBase64enDe.base64En(field.value,this.encryption)
          }else if(field.value && field.fieldCname=='cust_name'){
            val[field['fieldCname']] = minixBase64enDe.base64En(field.value,this.encryption)
          }else{
            val[field['fieldCname']] = field['value']
          }
          
        }
        
      })
      return val
    },
    //获取表单字段值（兼容原来全局组件）
    getFormData(type){
        if(type == 'save'){
            return this.getFormDataWithoutVerify()
        }
        return new Promise((resolve) => {
            let returnData = {
                returnCode: '0',
                OBJECT_NAME: this.OBJECT_NAME,
                values: {
                  order_no: this.allFieldsVal.order_no,
                  create_by: this.allFieldsVal.create_by_id,
                  // create_by_id: this.allFieldsVal.create_by_id,
                  order_name: this.allFieldsVal.order_name,
                  ...this._getVal()
                }
            }
            if(!this._verifyAllField()|| this.isHttping){
                returnData.returnCode = '1'
                returnData.values = {}
            }
            resolve(returnData)
        })
    },
    //获取表单字段值，无校验（兼容原来全局组件）
    getFormDataWithoutVerify(){
        return new Promise((resolve) => {
            resolve({
                returnCode: '0',
                OBJECT_NAME: this.OBJECT_NAME,
                values: {
                  order_no: this.allFieldsVal.order_no,
                  create_by: this.allFieldsVal.create_by_id,
                  // create_by_id: this.allFieldsVal.create_by_id,
                  order_name: this.allFieldsVal.order_name,
                  ...this._getVal()
                }
            })
        })
    },
    //
    customSubmit(){
        this._editSave()
    },
    //编辑保存
    _editSave(){
      let val = this._getVal()
      val.tenant_id = this.tenantId
      val.business_key = this.businessKey
      val.business_type = this.busType
      val.whereOf = {
        mt_id: this.mtId
      }
      var _info = JSON.parse(localStorage.user).info
      val.update_by = _info.userId
      val.ask_skill_group = _info.skillIds
      val.ask_dept = _info.orgId

      var params = {
        Head: {
          moId: this.moId,
          method: 'update',
          version: 'v1.0',
          business_key: this.businessKey
        },
        Data: [
          {
            state: '',
            moId: this.moId,
            OBJECT_NAME: this.OBJECT_NAME,
            modelId: null,
            approveTaskDate: {
              nextGroup: "",
              approveOpinion: ""
            },
            value: val
          }
        ]
      }
      return new Promise((resolve,reject) =>{
        this.$http.post('/scmd/custom/operCustom',params).then(({data}) => {
          console.log(data)
          this.isHttping = false
          if(data.returnCode == 0){
            resolve(data)
            this.$emit('on-success',data)
          }else{
            reject(data)
            this.$emit('on-fail',data)
          }
        })
      })
      
    },
    //新增保存
    _addSave(origin_params){
      origin_params = origin_params || {}
      let val = this._getVal() || {}
      var _info = JSON.parse(localStorage.user).info
      val = Object.assign(origin_params,val)//合并外部参数,以本地参数为主
      if(this.tenantId){
        val.tenant_id = this.tenantId
      }else{
        val.tenant_id = _info.tenantId
      }
      val.business_type = this.busType
      val.create_by = _info.userId
      val.ask_skill_group = _info.skillIds
      val.ask_dept = _info.orgId
      if(this.businessKey){
        val.business_key = this.businessKey
      }
      val.mt_id = '@id'
      var params = {
        Head: {
          moId: this.moId,
          method: 'insert',
          version: 'v1.0'
        },
        Data: [
          {
            state: '',
            moId: this.moId,
            OBJECT_NAME: this.OBJECT_NAME,
            modelId: null,
            approveTaskDate: {
              nextGroup: "",
              approveOpinion: ""
            },
            value: val
          }
        ]
      }
      return new Promise((resolve,reject) => {
        this.$http.post('/scmd/dynObject/operObjectCheck',params).then(({data}) => {
          this.isHttping = false
          if(data.returnCode == 0){
            if(data.bean.checkCode){
              resolve()
            }else{
              this.$Message.error(data.bean.errMsg)
            }
          }else{
            reject(data)
          }
        })
      })
      
    },
    // 遍历表单 取到加密标识，在提交的时候对"cust_phone"和"cust_name"加密
    getEncryption(){
      this.recursionFields(this.fields,(field)=>{
        if(field.fieldType=='2' && field.fieldCname=='encryption'){
          this.encryption = field.value||'0'; //没选默认不加密
        }
      })
    }
  }
}
</script>

<style scoped lang = "less">
.questionnaire-wrap{
  /* padding: 36px; */
  background:#fff;
}
</style>